import { SVGProps } from "react";

const GIPaperTray = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1em" height="1em" {...props}><path d="M0 0h512v512H0z" /><path fill="#fff" d="M87.902 40.998L42.25 391.002h138.566l32 48h86.368l32-48h138.568L424.098 40.998h-98.536l-16 32H202.587l-16.967-32H87.902zm-46.904 368v78.004h430.004v-78.004H340.816l-32 48H203.184l-32-48H40.998z" /></svg>;

export { GIPaperTray };